export const TERMS_AND_CONDITIONS_STRINGS = {
  'meta.title': 'Terms and Conditions | Belong',
  'meta.description': `Read our terms of use, copywrite policy, and more.`,
  'page.title': 'Terms Of Use',
  'page.updated': 'Last Updated ',
};
